import { Bell, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useToast, type ToastItem } from '../context/ToastContext.js';
import './ToastViewport.css';

function toastText(toast: ToastItem, t: ReturnType<typeof useTranslation>['t']): string {
  if (toast.literal) return toast.literal;
  return t(`notifications.${toast.kind}`, {
    actor: toast.actor ?? '',
    subject: toast.subject ?? '',
    defaultValue: toast.subject ?? toast.kind,
  });
}

export function ToastViewport() {
  const { toasts, dismissToast } = useToast();
  const { t } = useTranslation();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-viewport" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <div key={toast.id} className="toast">
          <span className="toast-icon">
            <Bell size={16} />
          </span>
          <p className="toast-text">{toastText(toast, t)}</p>
          <button
            type="button"
            className="toast-dismiss"
            onClick={() => dismissToast(toast.id)}
            aria-label={t('common.close')}
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
